module.exports = require("reselect");


//////////////////
// WEBPACK FOOTER
// external "reselect"
// module id = 36
// module chunks = 0